import { Box, Icon } from '@openfin/ui-library';
import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { AppLogo } from '../AppLogo/AppLogo';
import { NotificationTime } from '../NotificationTime/NotificationTime';
import { SingleLine } from '../SingleLine/SingleLine';

interface Props {
  sender: string;
  icon: string;
  date: number;
  onDismiss: (event: React.MouseEvent) => void;
  isToast?: boolean;
  uuid: string;
}

export const CardHeader: FC<Props> = (props) => {
  const { sender, date, icon, uuid, onDismiss, isToast } = props;
  return (
    <Container alignItems="center">
      <AppLogo src={icon} size="xlarge" alt={sender} uuid={uuid} data-testid="icon" />
      <Title data-testid="sender-title">
        {sender}
      </Title>

      <RightWrapper alignItems="center">
        <Time>
          <NotificationTime date={date} />
        </Time>
        <DismissIcon
          onClick={onDismiss}
          icon={isToast ? 'MinusCircledIcon' : 'CrossCircledIcon'}
          data-testid="dismiss-button"
        />
      </RightWrapper>
    </Container>
  );
};

const Container = styled(Box)`
  width: 100%;
  user-select: none;
  position: relative;
`;

const Title = styled(SingleLine)`
  flex: 1 1 100px;
`;

const RightWrapper = styled(Box)`
  justify-self: flex-end;
  margin-left: ${(props) => props.theme.px.base};
`;

const DismissIcon = styled(Icon)`
  position: absolute;
  right: 0;
`;

/** Selector for `CardHeaderHover` */
const Time = styled.div``;

/**
 * Add this to parent element to get hover effects for the header.
 */
export const CardHeaderHover = css`
  ${Time} {
    visibility: visible;
  }

  ${DismissIcon} {
    visibility: hidden;
  }

  &:hover {
    ${DismissIcon} {
      visibility: visible;
    }

    ${Time} {
      visibility: hidden;
    }
  }
`;
